import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

const SelectedContent = ({
  className
}) => /*#__PURE__*/React.createElement("div", {
  className: classNames(className, styles.container)
}, /*#__PURE__*/React.createElement("p", {
  className: styles.body
}, "You can select other items in the avatar section of the inventory page."));

export default SelectedContent;